import script from "./ComponentSandboxDynamicV2.vue?vue&type=script&lang=js"
export * from "./ComponentSandboxDynamicV2.vue?vue&type=script&lang=js"

export default script